import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import AddPollutionParams from "./AddPollutionParams";
import alertIcon from "@icons/ic-alert.svg";
import editIcon from "@icons/ic-edit-blue.svg";
import {
  PollutionInfo,
  LabelDiv,
  ValueDiv,
  AlertDiv,
  PaddingDiv,
  EditDiv,
  BoxDiv,
  PollutionSubDiv,
} from "./PollutionParams.styled";
import "../../CenterProductView.scss";

const PollutionParams = (props) => {
  const {
    t,
    polllutions,
    pollutionParam,
    strictLimit,
    setCenterProductData,
    companyId,
    centerId,
    centerProductId,
  } = props;

  const [isEditPollutionParam, setIsEditPollutionParam] = useState(false);

  const editPollutionParam = () => {
    setIsEditPollutionParam(!isEditPollutionParam);
  };

  return (
    <PollutionInfo>
      {!isEditPollutionParam && (
        <>
          <EditDiv>
            <Image
              src={editIcon}
              alt="Edit Polllution"
              onClick={editPollutionParam}
              className="center-products-view__image-icon"
            />
          </EditDiv>
          <PaddingDiv
            padding={strictLimit === 1 ? "3px 7% 30px 7%" : "30px 7% 30px 7%"}
          >
            {strictLimit === 1 && (
              <AlertDiv>
                <Image
                  src={alertIcon}
                  alt={t("STRICT_LIMITS_ALERT")}
                  title={t("STRICT_LIMITS_ALERT")}
                  className="center-products-view__image-icon-limit"
                />
                {t("STRICT_LIMITS_ALERT")}
              </AlertDiv>
            )}
            <BoxDiv>
              {polllutions !== null &&
                polllutions.map((polllution, index) => {
                  return (
                    <React.Fragment key={index}>
                      <PollutionSubDiv>
                        <LabelDiv>{polllution.label}</LabelDiv>
                        <ValueDiv>
                          {polllution.value !== null && polllution.value !== ""
                            ? polllution.value
                            : "-"}
                        </ValueDiv>
                      </PollutionSubDiv>
                    </React.Fragment>
                  );
                })}

              {polllutions === null &&
                pollutionParam.length > 0 &&
                pollutionParam.map((polllution, index) => {
                  return (
                    <React.Fragment key={index}>
                      <PollutionSubDiv>
                        <LabelDiv>{polllution.label}</LabelDiv>
                        <ValueDiv>-</ValueDiv>
                      </PollutionSubDiv>
                    </React.Fragment>
                  );
                })}
            </BoxDiv>
          </PaddingDiv>
        </>
      )}
      {isEditPollutionParam && (
        <AddPollutionParams
          polllutions={polllutions}
          pollutionParam={pollutionParam}
          strictLimit={strictLimit}
          editPollutionParam={editPollutionParam}
          setCenterProductData={setCenterProductData}
          companyId={companyId}
          centerId={centerId}
          centerProductId={centerProductId}
        />
      )}
    </PollutionInfo>
  );
};

PollutionParams.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PollutionParams);
